module.exports = __webpack_public_path__ + "static/media/TeamsIcon.3c2d82f3.png";